import React from 'react';

import {ConfirmPopover} from 'app/general/widgets/ConfirmPopover';
import {useAccountSettingsState} from 'app/settings/api';
import {useRemoveUser} from 'app/user/api';
import {gt} from 'app/utils/i18n';

import {UserDetailPageAddToTeamButton} from './UserDetailPageAddToTeamButton';

import type {UserSerializedType} from 'sweet-types';

interface Props {
  user: UserSerializedType;
  onRemove: () => unknown;
  onUpdate: () => unknown;
}

export function UserPageActionButtons({user, onRemove, onUpdate}: Props) {
  const {owner_email} = useAccountSettingsState().data!;
  const [removeUser, {isLoading: isRemoving}] = useRemoveUser();

  return (
    <span className="d-flex">
      {user.email !== owner_email ? (
        <ConfirmPopover
          text={gt('Tasks assigned to this member will be canceled')}
          placement="left"
          confirmText={gt('Yes, remove member')}
          onConfirm={() => removeUser(user.url).unwrap().then(onRemove)}
          isIdle={!isRemoving}
          busyText={gt('Removing Member...')}
        >
          {(handlers) => (
            <button
              {...handlers}
              className="btn btn-sm btn-link text-danger mr-2"
              title={gt('Remove Member')}
            >
              <i className="far fa-trash" />
            </button>
          )}
        </ConfirmPopover>
      ) : null}
      <UserDetailPageAddToTeamButton user={user} refreshList={onUpdate} />
    </span>
  );
}
